import request from '@/config/axios'

export const getFloorList = () => request.get({ url: '/rental/home/floor/list' })
export const getFloor = (id: number) => request.get({ url: '/rental/home/floor/get', params: { id } })
export const createFloor = (data: any) => request.post({ url: '/rental/home/floor/create', data })
export const updateFloor = (data: any) => request.put({ url: '/rental/home/floor/update', data })
export const deleteFloor = (id: number) => request.delete({ url: '/rental/home/floor/delete', params: { id } })
